///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GtthCustomerLocationService } from '../../../services/customer/customer-location.service';

@Component({
    selector: 'winde-single-price-show',
    templateUrl: './single-price-show.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthSinglePriceShowComponent {
    public currentPrice: number;
    public symbol: string;
    private currentCurrency: string;

    constructor(private readonly customerLocationService: GtthCustomerLocationService) {}

    @Input() set currency(value: string) {
        this.currentCurrency = value;
        this.symbol = this.customerLocationService.getCurrencySymbolByCode(this.currentCurrency);
    }

    @Input() set price(value: number) {
        this.currentPrice = value;
        this.symbol = this.customerLocationService.getCurrencySymbolByCode(this.currentCurrency);
    }
}
